import React,{useState, useEffect} from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
//components
import Settings from "./Settings";
import SoundButtonPlayer from './SoundButtonPlayer';

const LIGHT_MODE = "/assets/icons/light-mode.png";
const DARK_MODE = "/assets/icons/dark-mode.png";

const LM_NAME = "Light Mode";
const DM_NAME = "Dark Mode";

function DarkToggle(){
    const[currMode, setcurrMode]=useState("Light Mode");

    const imgToUse=currMode === "Light Mode" ? LIGHT_MODE : DARK_MODE;
    const btnName=currMode === "Light Mode" ? LM_NAME: DM_NAME;

    const toggleMode = ()=>{
        setcurrMode(prevMode=>
            prevMode === "Light Mode" ? "Dark Mode" : "Light Mode"
        );
    };

    useEffect(()=>{
         document.body.classList.remove('light-mode');
        // document.App.classList.remove('light-mode');
        document.body.classList.remove('dark-mode');

        if(currMode === "Light Mode"){
            document.body.classList.add('light-mode');
            // document.App.classList.add('light-mode');
        }
        else{
            document.body.classList.add('dark-mode');
            // document.App.classList.add('dark-mode');
        }
    },[currMode]);

    return(
        <div className="App">
            <SoundButtonPlayer onClick={toggleMode}>
                <Settings
                    settingImg={imgToUse}
                    settingName={btnName}
                />
            </SoundButtonPlayer>
        </div>
    )
}
export default DarkToggle;